/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Hire_NowInputs */

const en_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire Now`)
};

const ar_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وظّف الآن`)
};

const bn_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনই হায়ার করুন`)
};

const de_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt einstellen`)
};

const es_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar ahora`)
};

const fr_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embauchez maintenant`)
};

const pt_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrate agora`)
};

const zh_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即雇用`)
};

const tr_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Kirala`)
};

const ru_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наймите сейчас`)
};

const pl_ct_hire_now = /** @type {(inputs: Ct_Hire_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij teraz`)
};

/**
* | output |
* | --- |
* | "Hire Now" |
*
* @param {Ct_Hire_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_hire_now = /** @type {((inputs?: Ct_Hire_NowInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Hire_NowInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_hire_now(inputs)
	if (locale === "bn") return bn_ct_hire_now(inputs)
	if (locale === "de") return de_ct_hire_now(inputs)
	if (locale === "es") return es_ct_hire_now(inputs)
	if (locale === "fr") return fr_ct_hire_now(inputs)
	if (locale === "pt") return pt_ct_hire_now(inputs)
	if (locale === "zh") return zh_ct_hire_now(inputs)
	if (locale === "tr") return tr_ct_hire_now(inputs)
	if (locale === "ru") return ru_ct_hire_now(inputs)
	if (locale === "pl") return pl_ct_hire_now(inputs)
	return en_ct_hire_now(inputs)
});